var map = {
	"./404.json": 6648,
	"./account.json": 461,
	"./blockbuster.json": 8572,
	"./blog.json": 3203,
	"./cinema.json": 8892,
	"./faq.json": 2671,
	"./footer.json": 157,
	"./get-started.json": 8811,
	"./header.json": 9260,
	"./index.json": 1961,
	"./info.json": 8970,
	"./privacy.json": 2078,
	"./schools.json": 8599,
	"./sign-in.json": 6065,
	"./subreader-ambassadoer.json": 2549,
	"./subscription.json": 3276,
	"./terms.json": 4178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8845;